import React from "react";

//const baseURL = "http://192.168.1.12:8000";

const baseURL = "";


const config = {
  siteURL: "http://restroscans.com",
  apiBaseURL: `${baseURL}/site/`,
  staticBaseURL: `${baseURL}`,
  apiTimeout: 500000,
};
export default config;
